import { useState, useEffect } from 'react';
import firebase from 'firebase/app';

/**
 * Subscribe to the first client document matching an ownerId.
 * Returns [loading, client] where client has { id, ...data } or null.
 */
export function useClientForOwner(ownerId) {
  const [client, setClient] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (!ownerId) {
      setClient(null);
      setLoading(false);
      return () => {};
    }

    setLoading(true);
    const db = firebase.firestore();
    const query = db.collection('clients').where('ownerId', '==', ownerId).limit(1);

    const unsubscribe = query.onSnapshot(
      (snap) => {
        if (snap.size > 0) {
          const doc = snap.docs[0];
          setClient({ id: doc.id, ...doc.data() });
        } else {
          setClient(null);
        }
        setLoading(false);
      },
      (err) => {
        console.error('[useClientForOwner] snapshot error:', err);
        setClient(null);
        setLoading(false);
      }
    );

    return () => unsubscribe();
  }, [ownerId]);

  return [loading, client];
}
